/**
 * triggerinfos service
 */

import Resource from './resource'

export default new Resource('triggerinfos')



// WEBPACK FOOTER //
// ./src/libraries/services/triggerinfos.js